import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    createAwatChecklistNote: {
        method: 'POST',
        url: `${BASE_PATH_API}/awatchecklist/:id/note`
    },
    updateAwatChecklistNote: {
        method: 'PUT',
        url: `${BASE_PATH_API}/awatchecklist/:id/note`
    },
    deleteAwatChecklistNote: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/awatchecklist/:id/note`
    },
    updateAwatChecklist: {
        method: 'PUT',
        url: `${BASE_PATH_API}/awatchecklist/:id`
    },
    getUniqueStagesByNameForAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/awatchecklist/uniqueStages`
    },
    getAwatChecklistCountForAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/awatchecklist/accountChecklistCount`
    },
};

export function AwatChecklistApi() {
    return createActions(actions);
}
